<template>
  <div style="width: 100%" id="EquipmentVideo">
    <el-row :gutter="20">
      <el-col :span="6" style="padding-left: 5px;padding-right: 5px;">
        <el-upload
          class="avatar-uploader"
          :action ="uploadurl"
          :data="uploadParamBeverage"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :headers="uploadHeaders"
          style="float: left"
        >
          <el-button type="info">{{$t('upload')}}</el-button>
        </el-upload>
        <el-button type="primary" @click="deleteVideo" style="margin-left: 20px">{{$t('delete')}}</el-button>
        <el-button type="primary" @click="IssueVideo" style="margin-left: 20px">{{$t('issued')}}</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="margin-top:20px">
      <el-table
        :data="tableData"
        ref="multipleTable"
        style="width: 100%"
        class="tableBox"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          prop="file"
          :label="$t('video')"
          width="500">
          <template slot-scope="scope">
            <video
              :src="scope.row.path"
              controls="true"
              class="video-js vjs-big-play-centered vjs-fluid"
              webkit-playsinline="true"
              playsinline="true"
              x-webkit-airplay="allow"
              x5-playsinline
              style="width: 100%;max-height: 200px"
              autoplay="autoplay"
              ref="video">
            </video>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          :label="$t('name')"
          width="180">
        </el-table-column>
        <el-table-column
          prop="createdOn"
          :label="$t('time')">
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script >
export default {
  props:{
    filecatalog:null,
    equipmentId:null
  },
  data(){
    return {
      uploadHeaders: {authorization: "bearer " + this.$account.data.token},
      //uploadurl: "https://icloud.lhcoffeetime.com/api/File/Upload",
      uploadurl: this.$httpservice.host + "api/File/Upload",
      uploadParamBeverage: {filecatalog: this.filecatalog,equipmentId:this.equipmentId},
      beveragePics: [],
      formLabelWidth: '120',
      userTreeloading: true,
      beveragePicsCount: 0,
      currentPage: 1,

      player: null,
      playTime:'',
      seekTime:'',
      current:'',
      tableData: [],
      selected:[]
    }
  },

    created() {
      this.initTableData()
    },

  methods:{
    handleAvatarSuccess(res, file) {
      if(res.code == 200){
        this.$message.success(res.msg)
        // 刷新列表
        this.initTableData()
      }else{
        this.$message.error(res.msg)
        return
      }
    },
    beforeAvatarUpload(file) {

    },
    // 初始化tableData
    initTableData(){
      // 调用接口
      let param = {pageIndex:1,pageSize:10,fileCatalog:9}
      this.$httpservice.get('api/File/List',param).then(res => {
        if(res.body.code == 200){
          let tempArr = res.body.data
          // 循环数组，添加前缀
          tempArr.forEach(item=>{
            item.path = this.$prefix + item.path
          })
          this.tableData = tempArr
        }else{
          this.$message.error(res.body.msg)
        }
      })
    },
    handleSelectionChange(val){
      this.selected = []
      val.forEach(item=>{
        this.selected.push(item.id)
      })
    },
    deleteVideo(){
      if(this.selected.length==0){
        this.$message.error(this.$t('equipmentmanagement.tickAtLeastOneVideoToBeDeleted'))
        return
      }
      // 调接口删除
      this.$httpservice.post('api/File/Delete',this.selected).then(res=>{
        if(res.body.code == 200){
          this.$message.success(this.$t('deleteSuccessfully'))
          this.initTableData()
        }else{
          this.$message.error(res.body.msg)
          return
        }
      })
    },
    // 下发视频
    IssueVideo(){
      if(this.selected.length == 0){
        this.$message.error("请选择至少一条视频")
        return false
      }
      if(this.selected.length > 1){
        this.$message.error("请选择一条视频")
        return false
      }
      let param = {equipmentId:this.equipmentId.id,fileLibId:this.selected[0]}
      // 通知设备获取视频
      this.$httpservice.get('api/File/IssueVideo',param).then(res=>{
        console.log(res)
      })
    }
  }
}
</script>

<style lang="less" type="text/css">
  #EquipmentVideo{
    ._time-current{
      width: 70px!important;
    }
    ._time-amount{
      width: 70px!important;
    }
    .tableBox{
      th{
        height: 100px!important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/EquipmentVideo.vue